export default __webpack_public_path__ + "static/media/icons8-lock.bb23e786.svg";